/* eslint-disable */
import { FormControl, InputLabel, makeStyles, MenuItem, Select } from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { DropdownIcon } from "../../assets/Icons";
import { TextField } from "@material-ui/core";
import IRecipientDetailsProps from "./Recipient";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles(() => ({
  label: {
    marginLeft: "12px",
    paddingBottom: "4px",
  },
}));

export const StepTwo: FunctionComponent<IRecipientDetailsProps.StepTwoProps> = ({
  relationship,
  residenceCountry,
  setIsModalOpen,
  city,
  setCity,
  pin,
  setPin,
  address1,
  setAddress1,
  address2,
  setAddress2,
  setResidenceCountry,
  countryList,
  category,
}) => {
  const classes = useStyles();
  const [inputValue, setInputValue] = React.useState("");
  const specialCharRegExp = "[a-zA-Z0-9 ]{1,}";

  return (
    <div className="flex flex-col items-center space-y-10 justify-content">
      <div id="line1" className="flex space-x-20">
        <div
          id="relationship"
          onClick={() => {
            category === "Individual" ? setIsModalOpen("relationship") : null;
          }}
          className={`${
            category === "Individual"
              ? "flex items-center justify-between w-[400px] p-5 text-black bg-white border-2 border-gray-300 rounded-md cursor-pointer h-14"
              : "flex items-center justify-between w-[400px] p-5 text-black bg-gray-300 cursor-not-allowed  border-2 border-gray-300 rounded-md h-14"
          }`}
        >
          <div>{relationship ? `${relationship}` : "Relationship*"}</div>
          <div>
            <DropdownIcon />
          </div>
        </div>
        <div id="DTInput" className="flex flex-col">
          <Autocomplete
            value={residenceCountry}
            onChange={(event: any, newValue: string | null) => {
              setResidenceCountry(newValue);
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            id="controllable-states-demo"
            options={countryList}
            style={{ width: 400 }}
            renderInput={(params) => (
              <TextField {...params} required label="Country of Residence" variant="outlined" />
            )}
          />
        </div>
      </div>
      <div id="line2" className="flex space-x-20">
        <TextField
          className="w-[400px]"
          name="City"
          label="City"
          variant="outlined"
          required={true}
          onChange={(e) => setCity(e.target.value)}
          value={city}
          inputProps={{ pattern: { specialCharRegExp } }}
        />
        <TextField
          className="w-[400px]"
          name="pincode"
          label="PIN Code"
          variant="outlined"
          required={true}
          onChange={(e) => setPin(e.target.value)}
          value={pin}
          inputProps={{ pattern: { specialCharRegExp } }}
        />
      </div>
      <div id="line3" className="flex space-x-20">
        <TextField
          className="w-[400px]"
          name="address1"
          variant="outlined"
          label="Address Line 1"
          required={true}
          onChange={(e) => setAddress1(e.target.value)}
          value={address1}
          inputProps={{ pattern: { specialCharRegExp } }}
        />
        <TextField
          className="w-[400px]"
          name="address2"
          variant="outlined"
          label="Address Line 2"
          onChange={(e) => setAddress2(e.target.value)}
          value={address2}
          inputProps={{ pattern: { specialCharRegExp } }}
        />
      </div>
    </div>
  );
};
